import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from 'i18next-http-backend';
import { initReactI18next } from "react-i18next";
import { getRuntimeBasePath, getRemoteAssetOrigin } from 'shared/utils/runtimeBasePath';

// When embedded on a different origin (e.g. app.caribe7.dev), load translations from the remote's public URL.
function getLoadPath() {
  const origin = getRemoteAssetOrigin();
  const base = getRuntimeBasePath();
  if (origin) return `${origin}/locales/{{lng}}/{{ns}}.json`;
  return `${base || ''}/locales/{{lng}}/{{ns}}.json`;
}

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false, // set to true or use REACT_APP_LANG_TRANS_DEBUG=true for i18next debug logs

    // have a common namespace used around the full app
    // ns: ["translation"],
    // defaultNS: "translations",

    // Allow multi nested key in json
    keySeparator: '.',

    preload: ['en', 'it', 'es'],
    load: 'currentOnly',
    supportedLngs: ['en', 'es', 'it'],
    fallbackLng: "en",

    interpolation: {
       escapeValue: false,
    },
    backend: {
      // path where resources get loaded from, or a function
      // returning a path:
      // function(lngs, namespaces) { return customPath; }
      // the returned path will interpolate lng, ns if provided like giving a static path
      // the function might return a promise
      //
      // If allowMultiLoading is false, lngs and namespaces will have only one element each,
      // If allowMultiLoading is true, lngs and namespaces can have multiple elements
      loadPath: getLoadPath(),
    },

    react: {
       bindI18n: 'languageChanged loaded',
       useSuspense: false //   <---- this will do the magic
    }

  });

  export default i18n;